// babel-polyfill not needed with modern browsers and Node.js 18+
import React from "react";
import { createRoot } from "react-dom/client";
import { configure } from "mobx";
import "./body.scss";
import * as frowser from "frowser";
import smoothscroll from "smoothscroll-polyfill";
import ReactGA from "react-ga4";
import mobxSpyLogger from "mobx-spy-logger";

import SearchState from "./SearchState";
import Search from "./Search";
import "./i18n";

const bookFont = require("./lineto-circular-book.ttf");
const boldFont = require("./lineto-circular-bold.ttf");

const GA_TRACKING_ID = "UA-24437371-1";
const browser = frowser.getParser(window.navigator.userAgent);

// Polyfill smooth scrolling on Safari
if (browser.getBrowserName() === "Safari") {
  console.log("installing smooth scrolling polyfill for Safari");
  smoothscroll.polyfill();
}

configure({
  enforceActions: "observed"
});

// Suppress findDOMNode errors/warnings from legacy libraries and react-transition-group in React 19
const originalError = console.error;
const originalWarn = console.warn;
console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    (args[0].includes("findDOMNode is deprecated") ||
     args[0].includes("findDOMNode is not a function"))
  ) {
    return;
  }
  originalError.call(console, ...args);
};
console.warn = (...args) => {
  if (
    typeof args[0] === "string" &&
    args[0].includes("findDOMNode is deprecated")
  ) {
    return;
  }
  originalWarn.call(console, ...args);
};

const init = () => {
  ReactGA.initialize(GA_TRACKING_ID, {
    debug: false
  });
  fetch(bookFont).then(() => {
    fetch(boldFont).then(() => {
      if (document.body != null) {
        const body = document.body;

        body.innerHTML = "";
        // const reactRoot = document.getElementById('react-root');
        const reactRoot = document.createElement("div");
        reactRoot.id = "react-root";
        body.appendChild(reactRoot);

        if (reactRoot != null) {
          console.log(`React.version: ${React.version}`);
          const searchState = new SearchState();

          window.addEventListener("popstate", searchState.refreshSearchFromURL);
          createRoot(reactRoot).render(<Search store={searchState} />);
        }
      }
    });
  });
};

if (document != null) {
  if (document.readyState === "complete") {
    init();
  } else {
    window.addEventListener(
      "load",
      () => {
        init();
      },
      false
    );
  }
}
